import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { JobsSchedulerService } from './job-scheduler.service';

@Component({
  selector: 'ngx-job-scheduler',
  templateUrl: './job-scheduler.component.html',
  styleUrls: ['./job-scheduler.component.scss']
})
export class JobSchedulerComponent implements OnInit {

  public listJobs = null;
  public formJobScheduler: FormGroup = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private notificationService: NotificationsService,
    private spinnerService: NgxSpinnerService,
    private service: JobsSchedulerService,
  ) {
    this.listJobs = [
      {
        name: 'PROCCESS_ACCOUNTS',
        description: 'Processar Contas Empresa'
      },
      {
        name: 'PROCCESS_ACCOUNTS_ADDRESS',
        description: 'Processar Contas Empresa Endereço'
      },
      {
        name: 'PROCCESS_ACCOUNTS_PHONE',
        description: 'Processar Contas Empresa Telefone'
      },
      {
        name: 'PROCCESS_PAYMENT_ACCOUNTS',
        description: 'Processar Contas Pagamento Empresa'
      },
      {
        name: 'PROCCESS_CARDS',
        description: 'Processar Cartões Empresa'
      },
      {
        name: 'PROCESS_PERSON_PROCCESS_ACCOUNTS',
        description: 'Processar Conta Pessoa'
      },
      {
        name: 'PROCESS_PERSON_PROCCESS_CARDS',
        description: 'Processar Cartões Pessoa'
      },
      {
        name: 'PROCESS_SCHEDULER_PIX_VERIFICATION',
        description: 'Processar Verificação de Transações PIX'
      },
      {
        name: 'PROCESS_SCHEDULER_PENDING_PIX_VERIFICATION',
        description: 'Processar Verificação de PIX Pendentes'
      },
    ];
  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.formJobScheduler = this.formBuilder.group({
      job: [null, Validators.required],
    });
  }

  executeJob(data: any) {

    if (!this.formJobScheduler.valid) {
      this.notificationService.alert(
        'Formulário inválido!',
        'Preencha os campos do formulário adequadamente.',
        {
          timeOut: 0,
          showProgressBar: true,
          pauseOnHover: true,
          clickToClose: true,
          clickIconToClose: true,
        }
      );
      return;
    }

    let register = {
      job: data.job
    };

    this.spinnerService.show();

    this.service.executeJob(register, (response => {
      this.spinnerService.hide();
      if (response.success) {
        this.notificationService.success(response.message);
      } else {
        this.notificationService.error(response.message);
      }
    }), (error) => {
      this.spinnerService.hide();
      this.notificationService.error(error.message);
    });
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
  
}
